@for (i of [1, 2, 3, 4, 5]; track i) {
  <app-custom-icons
    [type]="iconTypes.STAR"
    class="star"
    (mouseover)="setRate(i)"
    (click)="saveRate(i)"
    (keydown.space)="saveRate(i)"
    [attr.tabindex]="disabled ? null : 0"
  ></app-custom-icons>
}
